import { PropsWithChildren, useEffect } from "react";
import { useSessionContext } from "../context/SessionContext";
import { useGetSession } from "../api/useAuth";
import { useTaxContext } from "../context/TaxContext";
import { useGetTax } from "../api/useTax";
import { Loader } from "./Loader";

export const ContextWrapper = (props: PropsWithChildren & { preloadTax?: boolean }) => {
    const [session, setSession, setInitialized] = useSessionContext((state) => [
        state.session,
        state.setSession,
        state.setInitialized,
    ]);
    const [tax, setTax] = useTaxContext((state) => [state.tax, state.setTax]);

    const sessionQuery = useGetSession();
    const taxQuery = useGetTax(session?.country || null);

    useEffect(() => {
        if (sessionQuery.isFetched && sessionQuery.isSuccess) {
            setSession(sessionQuery.data);
            setInitialized(true);
        } else if (sessionQuery.isFetched) {
            setInitialized(true);
        }
    }, [sessionQuery.isSuccess, sessionQuery.isFetched]);

    useEffect(() => {
        if (taxQuery.isFetched && taxQuery.isSuccess) {
            setTax(taxQuery.data);
        } else if (taxQuery.isError) {
            try {
                if (
                    // @ts-ignore axios returns the error in error.response
                    taxQuery.error.response.data === "Could not determine country" ||
                    // @ts-ignore axios returns the error in error.response
                    taxQuery.error.response.status === 404
                ) {
                    setTax({
                        tax_rate: 0,
                        numeric: "",
                        currency: [],
                    });
                }
            } catch {}
        }
    }, [taxQuery.isSuccess, taxQuery.isFetched, taxQuery.isError]);


    return <>{!props.preloadTax || tax ? props.children : <Loader wrapperStyle={{ "justify-content": "center" }} />}</>;
};
